import jQuery from './jquery/jquery-1.12.4';

/**
 * jQuery UI
 */
import './jquery-plugins/jquery-ui';

/**
 * Compatibility polyfills
 * Filling the holes removed in 1.9
 * */
import './jquery-polyfills/jquery-polyfills';

/**
 * Plugins
 */
import 'chosen-js/chosen.jquery';
import 'jquery-slimscroll/jquery.slimscroll';
import 'jquery-placeholder/jquery.placeholder';
import 'jquery.numeric/jquery.numeric';
import 'jquery-countdown/dist/jquery.countdown';
import './jquery-plugins/jquery.history';
import './jquery-plugins/jquery.form';
import './jquery-plugins/jquery.datepicker';

/**
 * Non jQuery plugins
 */
import IScroll from 'iscroll/build/iscroll';

/**
 * jQuery CSS
 */
import '../styles/jquery/jquery.tags-input.css';
import '../styles/jquery/chosen.css';

import 'moment';
import 'dropzone';

window.IScroll = IScroll;

/**
 * Hacky, but needed to avoid conflict with Prototype
 */
window.$j = jQuery.noConflict();
window.jQuery = jQuery.noConflict();

/** Fixes for JQuery UI default behaviors */
import './jquery-plugins/jquery-ui.fix';
